module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard E. Burnett, Mark A. Noll\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Richard E. Burnett")]), _vm._v(" is executive director and managing editor of "), _c('I', [_vm._v("Theology Matters")]), _vm._v(". He is an ordained minister in the Presbyterian Church (PCUSA) and was formerly professor of systematic theology at Erskine Theological Seminary. His previous books include "), _c('I', [_vm._v("Karl Barth's Theological Exegesis: The Hermeneutical Principles of the Römerbrief Period")]), _vm._v(". ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jCfDYU/tc-custom/9781467467940.jpg?1733084689792",
      "alt": "This image is the cover for the book Machen's Hope"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Machen's Hope\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The first critical biography of J. Gresham Machen, examining the full arc of his intellectual career")]), _c('br'), _c('br'), _vm._v(" J. Gresham Machen is known as a conservative hero of the fundamentalist-modernist controversy. But was he always so staunchly antimodernist?   "), _c('br'), _c('br'), _vm._v(" In this sweeping new biography, Richard E. Burnett examines the whole of Machen’s life and career—from his early years at Princeton, to his experience in the First World War, to his founding of Westminster Theological Seminary . Burnett pays special attention to topics that have received little attention from biographers, like Machen’s crisis of faith and his support for historical criticism of Scripture. "), _c('br'), _c('br'), _vm._v(" Incorporating all of Machen’s major works as well as his previously unpublished private correspondence, Burnett crafts a nuanced narrative of Machen’s intellectual journey from enthusiastic modernist to stalwart conservative. Nuanced and thorough, "), _c('i', [_vm._v("Machen’s Hope")]), _vm._v(" will challenge scholars’ assumptions about Machen and his dynamic era.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0